import { TranslationKeys, translations } from './translations';


/**
 * Retrieves the translation for a given key and language.
 * @param key - The translation key. Either a string or a TranslationKeys type.
 * @param lang - The locale code (e.g., 'en', 'sv-se').
 * @returns The translated string or a fallback string if not found.
 */
export function getTranslation(key: string | TranslationKeys, lang: string): string {
    const langLower = lang.toLowerCase();
    const keyLower = key.toLowerCase();
    const translation = translations[langLower as keyof typeof translations];
    const fallbackString = `missing-translation-for-${key}-in-${lang}`;
    if (translation) {
        return translation[keyLower as keyof typeof translation] || fallbackString;
    }
    return fallbackString;
}